var $40e49c6c9e6fa358$exports = {};
$40e49c6c9e6fa358$exports = {
    "Clear search": `T\xfchjenda otsing`
};


export {$40e49c6c9e6fa358$exports as default};
//# sourceMappingURL=et-EE.mjs.map
